import { API_URLS } from 'constants/apiUrls';
import { IAuthDecorator } from 'decorators/AuthDecorator/interfaces/IAuthDecorator';
import {
    IAuthenticateResponse,
    IReverseAuthenticateResponse,
    IAuthenticateParams,
    IAuthRefreshToken,
} from './interfaces';

export default class AuthRepository {
    constructor(private readonly httpClient: IAuthDecorator) {}

    public setToken = (token: string) => {
        this.httpClient.setToken(token);
    };

    public setPartnerCode = (partnerCode: string) => {
        this.httpClient.setPartnerCode(partnerCode);
    };

    public authenticate = (params: IAuthenticateParams): Promise<IAuthenticateResponse> =>
        this.httpClient.get<IAuthenticateResponse, IAuthenticateParams>(API_URLS.AUTHENTICATE, {
            params,
        });

    public authenticateReverse = (query: string): Promise<IReverseAuthenticateResponse> =>
        this.httpClient.get<IReverseAuthenticateResponse, IAuthenticateParams>(
            `${API_URLS.AUTHENTICATE_REVERSE}${query}`,
        );

    public refreshToken(): Promise<IAuthRefreshToken> {
        return this.httpClient.get<IAuthRefreshToken>(API_URLS.REFRESH_TOKEN);
    }
}
